import { render, staticRenderFns } from "./IAGResponses.vue?vue&type=template&id=2b008529"
import script from "./IAGResponses.vue?vue&type=script&lang=js"
export * from "./IAGResponses.vue?vue&type=script&lang=js"
import style0 from "./IAGResponses.vue?vue&type=style&index=0&id=2b008529&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports